export default function labelForPFid(pfId){
    if(!pfId){
        return "";
    }
    let label = pfId.split(".");
    if(label.length>1){
      return (label[0].split('').join(" ")+" dot "+label[1].split('').join(" "));  //if pfId is in dot format
    }
      return pfId;
  }